import { render, staticRenderFns } from "./TicketStatusDate.vue?vue&type=template&id=51510aa4&"
import script from "./TicketStatusDate.vue?vue&type=script&lang=js&"
export * from "./TicketStatusDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports